import React from 'react';
import { connect } from 'react-redux';
import _includes from 'lodash.includes';
import _map from 'lodash.map';
// Actions
import { addItem, removeItem } from '../actions/actions_user';
// components
import Item from './Item';
import ItemCheckbox from './ItemCheckbox';
import { List, Divider } from 'semantic-ui-react';

class ChecklistBody extends React.Component {
	constructor(props) {
		super(props);
		/*
            Parent's props
                - user
                - list
        */
		this.handleChecking = this.handleChecking.bind(this);
		console.log(props);
	}

	handleChecking(itemId, checked) {
		console.log(`handleChecking called: ${itemId}, ${checked}`);

		if (checked === false) {
			// add item
			this.props.addItem(this.props.user.userId, this.props.list['list_id'], itemId);
		} else {
			// remove item
			this.props.removeItem(this.props.user.userId, this.props.list['list_id'], itemId);
		}
	}

	render() {
		let listId = this.props.list['list_id'];
        let items = this.props.list.items;
        
        if (!items || Array.isArray(items) === false || items.length === 0) return <div>Diese Checkliste ist leer.</div>

		return (
			<List className="item-list" selection>
				{_map(items, item => {
					if (this.props.userLoaded) {
						let checkedItemsObject = this.props.user.checkedItems[listId];
						let checkedItems = typeof checkedItemsObject !== 'undefined' && checkedItemsObject.items;
						let isChecked = typeof checkedItems !== 'undefined' ? _includes(checkedItems, item['item_id']) : false;

						return (
							<div key={item['item_id']}>
								<List.Item>
									<ItemCheckbox
										key={item['item_id']}
										itemId={item['item_id']}
										checked={isChecked}
										content={item.content}
										infoUrl={item['info_url']}
										type={item['type']}
										handleChange={this.handleChecking}
									/>
								</List.Item>
								<Divider />
							</div>
						);
					} else {
						return <Item key={item['item_id']} content={item.content} infoUrl={item['info_url']} type={item['type']} />;
					}
				})}
			</List>
		);
	}
}

// // Map Redux state to component props
// const mapStateToProps = (state, ownProps) => {
//     return {
//         noUser: _isEmpty(state.user) ? true : false
//     }
// }

export default connect(
	null,
	{ addItem, removeItem }
)(ChecklistBody);



// WEBPACK FOOTER //
// ./src/components/ChecklistBody.js